const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+Preview+Settings+API

function updatePreviewSettings(params) {
    const url = '/api/util/previewSettings';

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(params)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = updatePreviewSettings;
